<template>
  <b-modal id="bv-modal-reclamacao-transito" size="lg" title="Ocorrência de trânsito" scrollable centered>
    <div class="modal-log">

    <fieldset class="made-up" v-if="this.getlogchat.solicitacaoHora || this.getlogchat.solicitacaoPlaca || this.getlogchat.solicitacaoAssunto || this.getlogchat.solicitacaoTexto">
        <legend>Ocorrência</legend>
        <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.solicitacaoHora">
				<label for="solicitacaoHora"><strong>Hora</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoHora" type="text" id="solicitacaoHora" name="solicitacaoHora" disabled>
			</div>

            <div class="col-md-12" v-if="this.getlogchat.solicitacaoPlaca">
				<label for="solicitacaoPlaca"><strong>Placa</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoPlaca" type="text" id="solicitacaoPlaca" name="solicitacaoPlaca" disabled>
			</div>

            <div class="col-md-12" v-if="this.getlogchat.solicitacaoAssunto">
				<label for="solicitacaoAssunto"><strong>Assunto</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoAssunto" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoTexto">
				<label for="solicitacaoTexto"><strong>Texto</strong></label>
                <textarea v-model="this.getlogchat.solicitacaoTexto" rows="8" disabled></textarea>
			</div>
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.contato || this.getlogchat.protocolo || this.getlogchat.endereco || this.getlogchat.cidade || this.getlogchat.created_at">
        <legend>Dados do Atendimento</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.contato">
				<label for="whatsapp"><strong>WhatsAPP</strong></label>
				<input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
			</div>
          
            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
				<label for="protocolo"><strong>Protocolo</strong></label>
				<input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo" name="protocolo" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
				<label for="endereco"><strong>Endereço</strong></label>
				<input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cidade">
				<label for="cidade"><strong>Cidade</strong></label>
				<input class="form-control" v-model="this.getlogchat.cidade" type="text" id="cidade" name="cidade" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
				<label for="created_at"><strong>Data</strong></label>
				<input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at" name="created_at" disabled>
			</div>
            
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.data">
        <legend>Dados do Cliente</legend>
        <div class="row espcPlacas" v-for="ocorrencia in this.getlogchat.data">
            <div class="col-md-12" v-if="ocorrencia.Placa">
                <label for="placa"><strong>Placa</strong></label>
                <input class="form-control" v-model="ocorrencia.Placa" type="text" id="placa" name="placa" disabled>
            </div>

            <div class="col-md-12" v-if="ocorrencia.NomeBase">
                <label for="NomeBase"><strong>Nome da Base</strong></label>
                <input class="form-control" v-model="ocorrencia.NomeBase" type="text" id="NomeBase" name="NomeBase" disabled>
            </div>

            <div class="col-md-12" v-if="ocorrencia.SiglaBase">
                <label for="SiglaBase"><strong>Sigla da Base</strong></label>
                <input class="form-control" v-model="ocorrencia.SiglaBase" type="text" id="SiglaBase" name="SiglaBase" disabled>
            </div>
        </div>
    </fieldset>

    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
            variant="danger"
            class="float-right"
            @click="downloadPdf()"
        >
          Baixar PDF
        </b-button>
      </div>
    </template>

    <VueHtml2pdf
        class="d-none"
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :filename="mensagens"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="modal-log">

    <fieldset class="made-up" v-if="this.getlogchat.solicitacaoHora || this.getlogchat.solicitacaoPlaca || this.getlogchat.solicitacaoAssunto || this.getlogchat.solicitacaoTexto">
        <legend>Ocorrência</legend>
        <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.solicitacaoHora">
				<label for="solicitacaoHora"><strong>Hora</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoHora" type="text" id="solicitacaoHora" name="solicitacaoHora" disabled>
			</div>

            <div class="col-md-12" v-if="this.getlogchat.solicitacaoPlaca">
				<label for="solicitacaoPlaca"><strong>Placa</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoPlaca" type="text" id="solicitacaoPlaca" name="solicitacaoPlaca" disabled>
			</div>

            <div class="col-md-12" v-if="this.getlogchat.solicitacaoAssunto">
				<label for="solicitacaoAssunto"><strong>Assunto</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacaoAssunto" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoTexto">
				<label for="solicitacaoTexto"><strong>Texto</strong></label>
                <div class="textoPDF">{{ this.getlogchat.solicitacaoTexto }}</div>
			</div>
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.contato || this.getlogchat.protocolo || this.getlogchat.endereco || this.getlogchat.cidade || this.getlogchat.created_at">
        <legend>Dados do Atendimento</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.contato">
				<label for="whatsapp"><strong>WhatsAPP</strong></label>
				<input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
			</div>
          
            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
				<label for="protocolo"><strong>Protocolo</strong></label>
				<input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo" name="protocolo" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
				<label for="endereco"><strong>Endereço</strong></label>
				<input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cidade">
				<label for="cidade"><strong>Cidade</strong></label>
				<input class="form-control" v-model="this.getlogchat.cidade" type="text" id="cidade" name="cidade" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
				<label for="created_at"><strong>Data</strong></label>
				<input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at" name="created_at" disabled>
			</div>
            
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.data">
        <legend>Dados do Cliente</legend>
        <div class="row espcPlacas" v-for="ocorrencia in this.getlogchat.data">
            <div class="col-md-12" v-if="ocorrencia.Placa">
                <label for="placa"><strong>Placa</strong></label>
                <input class="form-control" v-model="ocorrencia.Placa" type="text" id="placa" name="placa" disabled>
            </div>

            <div class="col-md-12" v-if="ocorrencia.NomeBase">
                <label for="NomeBase"><strong>Nome da Base</strong></label>
                <input class="form-control" v-model="ocorrencia.NomeBase" type="text" id="NomeBase" name="NomeBase" disabled>
            </div>

            <div class="col-md-12" v-if="ocorrencia.SiglaBase">
                <label for="SiglaBase"><strong>Sigla da Base</strong></label>
                <input class="form-control" v-model="ocorrencia.SiglaBase" type="text" id="SiglaBase" name="SiglaBase" disabled>
            </div>
        </div>
    </fieldset>

    </div>
      </section>
    </VueHtml2pdf>
  </b-modal>
</template>
<script>
import {mapGetters} from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components:{
    VueHtml2pdf
  },

  data:() => ({
    mensagens: 'mensagens_' + window.moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
  }),

  computed:{
    ...mapGetters(['getlogchat'])
  },

  methods:{
    async openModal() {
        this.$bvModal.show('bv-modal-reclamacao-transito');
    },

    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    }
  }
}
</script>

<style scoped>
    .modal-log{
        overflow-y: auto;
        overflow-x: hidden;
    }

    .modal-log .espcForm{
        margin: 5px 0px 0px 0px;
    }

    .modal-log label, input, textarea{
        font-size: 12px;
    }
    .made-up{
        font-family: arial;
        margin: 10px;
        border-radius: 10px;
        background: #fff;
        border: solid 1px #9797A6;
        border-radius: 2px;
        padding: 10px;
    }

    .made-up fieldset{
        margin: 5px 30px;
    }

    .made-up legend{
        background: #1C869A; 
        color: #FEFEFE;
        margin: 0px;
        padding: 5px 20px;
        width: auto;
        font-size: 14px;
        border-radius: 2px;
    }
    .avoid-page-break {
      page-break-inside: avoid;
    }

    textarea{
        display: inline-block;
        width: 100%;
        padding: 0px 10px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .textoPDF{
        display: inline-block;
        width: 100%;
        padding: 0px 10px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .espcPlacas{
        margin: 0px 0px 20px 0px;
    }
</style>